import { render, staticRenderFns } from "./AppVersionBox.vue?vue&type=template&id=239ceff6&scoped=true"
import script from "./AppVersionBox.vue?vue&type=script&lang=js"
export * from "./AppVersionBox.vue?vue&type=script&lang=js"
import style0 from "./AppVersionBox.vue?vue&type=style&index=0&id=239ceff6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239ceff6",
  null
  
)

export default component.exports